// Mobile Filter Functionality for CloudSearch
document.addEventListener('DOMContentLoaded', function() {
  // Check if we're on a collection or search page
  const isFilterPage = document.querySelector('#cloud_search_filters_sidebar') || document.querySelector('#cloud_search_filters_root');
  
  if (!isFilterPage) return;
  
  // Create mobile filter toggle button
  const createMobileFilterToggle = () => {
    const button = document.createElement('button');
    button.className = 'mobile-filter-toggle';
    button.style.display = 'none'; // Hidden by default, CSS will show on mobile
    button.innerHTML = `
      <div class="filter-text">
        <span>Filters</span>
      </div>
      <div class="filter-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="margin-left: 4px;">
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
      </div>
    `;
    
    // Find the right place to insert the button
    const collectionNav = document.querySelector('.collection__nav');
    const productsContainer = document.querySelector('.collection__products');
    
    if (collectionNav) {
      // Insert after the collection nav
      collectionNav.parentNode.insertBefore(button, collectionNav.nextSibling);
    } else if (productsContainer) {
      // Insert before products if no nav
      productsContainer.parentNode.insertBefore(button, productsContainer);
    }
    
    return button;
  };
  
  // Create mobile filter drawer
  const createMobileFilterDrawer = () => {
    // Create drawer
    const drawer = document.createElement('div');
    drawer.className = 'mobile-filter-drawer';
    drawer.innerHTML = `
      <div class="mobile-filter-header">
        <h3>Filters</h3>
        <button class="mobile-filter-close" aria-label="Close filters">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      <div class="mobile-filter-content"></div>
    `;
    
    // Create overlay
    const overlay = document.createElement('div');
    overlay.className = 'mobile-filter-overlay';
    
    document.body.appendChild(drawer);
    document.body.appendChild(overlay);
    
    return { drawer, overlay };
  };
  
  // Initialize mobile filters
  const initMobileFilters = () => {
    const toggleButton = createMobileFilterToggle();
    const { drawer, overlay } = createMobileFilterDrawer();
    
    // Move CloudSearch filters to mobile drawer and update count
    const moveFiltersToDrawer = () => {
      const sidebarFilters = document.querySelector('#cloud_search_filters_sidebar');
      const mobileContent = drawer.querySelector('.mobile-filter-content');
      
      if (sidebarFilters && window.innerWidth <= 767) {
        // Instead of cloning, move the actual element
        mobileContent.innerHTML = '';
        
        // Check if filters are already in the drawer
        if (sidebarFilters.parentElement !== mobileContent) {
          // Store original parent
          if (!sidebarFilters.dataset.originalParent) {
            sidebarFilters.dataset.originalParent = sidebarFilters.parentElement.className || 'body';
          }
          
          // Move to drawer
          mobileContent.appendChild(sidebarFilters);
        }
        
        // Update filter count
        updateFilterCount();
        
        // Trigger CloudSearch to re-initialize if needed
        window.dispatchEvent(new Event('resize'));
      }
    };
    
    // Update filter count in toggle button
    const updateFilterCount = () => {
      const activeFilters = document.querySelectorAll('#cloud_search_filters_sidebar .cloud-search-active-filter');
      const filterText = toggleButton.querySelector('.filter-text span');
      
      if (activeFilters.length > 0) {
        filterText.innerHTML = `Filters <span class="filter-count">${activeFilters.length}</span>`;
      } else {
        filterText.textContent = 'Filters';
      }
    };
    
    // Return filters to original position
    const returnFiltersToOriginal = () => {
      const sidebarFilters = document.querySelector('#cloud_search_filters_sidebar');
      if (sidebarFilters && sidebarFilters.dataset.originalParent && window.innerWidth > 767) {
        const originalParent = document.querySelector(`.${sidebarFilters.dataset.originalParent}`) || document.body;
        if (sidebarFilters.parentElement !== originalParent) {
          originalParent.appendChild(sidebarFilters);
        }
      }
    };
    
    // Toggle drawer
    const toggleDrawer = (open) => {
      if (open) {
        drawer.classList.add('active');
        overlay.classList.add('active');
        document.body.style.overflow = 'hidden';
        // Small delay to ensure CloudSearch is ready
        setTimeout(() => {
          moveFiltersToDrawer();
        }, 100);
      } else {
        drawer.classList.remove('active');
        overlay.classList.remove('active');
        document.body.style.overflow = '';
        // Return filters on desktop
        if (window.innerWidth > 767) {
          returnFiltersToOriginal();
        }
      }
    };
    
    // Event listeners
    toggleButton.addEventListener('click', () => toggleDrawer(true));
    drawer.querySelector('.mobile-filter-close').addEventListener('click', () => toggleDrawer(false));
    overlay.addEventListener('click', () => toggleDrawer(false));
    
    // Handle window resize
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        if (window.innerWidth > 767) {
          toggleDrawer(false);
          returnFiltersToOriginal();
        }
      }, 250);
    });
    
    // Watch for CloudSearch initialization and filter changes
    const watchForCloudSearch = () => {
      let attempts = 0;
      const checkInterval = setInterval(() => {
        attempts++;
        const sidebarFilters = document.querySelector('#cloud_search_filters_sidebar');
        const hasFilters = sidebarFilters && sidebarFilters.querySelector('.cloud-search-filter-group');
        
        if (hasFilters) {
          clearInterval(checkInterval);
          console.log('CloudSearch filters found after', attempts, 'attempts');
          
          // Update filter count immediately
          updateFilterCount();
          
          // Watch for filter changes
          const observer = new MutationObserver((mutations) => {
            updateFilterCount();
          });
          
          observer.observe(sidebarFilters, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class']
          });
          
          // Re-initialize mobile drawer if it's open
          if (window.innerWidth <= 767 && drawer.classList.contains('active')) {
            setTimeout(() => {
              moveFiltersToDrawer();
            }, 100);
          }
        } else if (attempts > 20) {
          clearInterval(checkInterval);
          console.log('CloudSearch filters not found after 10 seconds');
        }
      }, 500);
    };
    
    watchForCloudSearch();
  };
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileFilters);
  } else {
    initMobileFilters();
  }
});